var getIconSize = function getIconSize(props) {
  switch (props.size) {
    case 'small':
      return '18px';

    case 'medium':
      return '28px';

    case 'large':
      return '30px';

    default:
      return '24px';
  }
};

export default {
  getIconSize: getIconSize
};